<template>
  <app-layout>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl lg:mt-12 lg:mb-10 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">
      <h2 class="w-full capitalize text-center mb-8 text-dark-blue">{{ $trans('app.menu.contact') }}</h2>
      <jet-validation-errors class="w-full text-center mb-8"/>

      <p v-show="status" class="w-full lg:w-3/4 text-center mb-4 font-medium bg-green-200 font-bold py-2 rounded-lg"
         v-html="status"></p>

      <form @submit.prevent="submit" class="lg:w-3/4">
        <div>
          <jet-label for="email" value="Email"/>
          <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus/>
        </div>

        <div class="mt-4">
          <jet-label for="message" value="Message"></jet-label>
          <textarea name="message" id="message" cols="30" rows="10" v-model="form.message" required
                    class="w-full mt-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"></textarea>
        </div>

        <div class="flex flex-col sm:flex-row items-center justify-center md:justify-end mt-4 w-full">
          <bubble-button class="sm:ml-4 sm:order-2" :class="{ 'opacity-25': form.processing }"
                         :disabled="form.processing">
            {{ $trans('app.send') }}
          </bubble-button>
        </div>
      </form>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import BubbleButton from "@/Components/BubbleButton";
import {trans} from "matice";

export default {
  components: {
    AppLayout,
    BubbleButton,
    JetInput,
    JetLabel,
    JetValidationErrors
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        message: ''
      }),

      status: null
    }
  },

  methods: {
    submit() {
      this.form
          .post(this.route('contact.send'), {
            onFinish: () => {
              this.form.reset('email', 'message')
            },
            onSuccess: () => {
              this.form.reset('email', 'message')
              this.status = trans('app.message-sent')
            }
          })
    }
  }
}
</script>
